import { captureError } from "@/lib/monitoring";
import { useConfigCatFeatureFlag } from "@/network/useConfigCatFeatureFlag";
import { useMemo } from "react";
import {
  type TranslatorOption,
  parseTranslatorOptions,
} from "../utils/translatorOptions";

/**
 * Returns the interpreters providers can pick from in the Tray, or null when
 * the `languageline-translator-options` flag is unset or malformed.
 */
export const useTranslatorOptions = (): TranslatorOption[] | null => {
  const { data: flagValue } = useConfigCatFeatureFlag(
    "languageline-translator-options",
  );

  return useMemo(() => {
    try {
      return parseTranslatorOptions(flagValue);
    } catch (error) {
      captureError(
        error instanceof Error
          ? error
          : new Error("Invalid languageline-translator-options flag"),
      );
      return null;
    }
  }, [flagValue]);
};
